import NavItem from 'gatsby-theme-pages/src/components/nav/list-nav/nav-item';
import activeClassName from 'gatsby-theme-pages/src/components/nav/activeClassName';
import styled from 'styled-components';

export default styled(NavItem)`
  color: white;
  transition: .2s;
  &:hover,
  .${activeClassName} {
    color: ${({ theme }) => theme.primaryColor};
  }
`;
